import { render } from "./DeleteSuccess.vue?vue&type=template&id=d10ad11c&ts=true"
import script from "./DeleteSuccess.vue?vue&type=script&lang=ts"
export * from "./DeleteSuccess.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__